import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useFriends(params = {}) {
  const { token, user } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchFriends() {
      setLoading(true);
      const { response, data } = await API.fetchFriends(token, user?.id, params);

      if (response.ok) {
        setResult(data);
        setLoading(false);
      } else {
        setError({ status: response.status, ...data });
        setLoading(false);
      }
    }

    fetchFriends();
  }, [Object.values(params).join("__")]);

  return {
    loading,
    friends: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
